export default "__VITE_ASSET__LkS_$UIO__"